import { PARTNER_BANKS } from "@constants/partnerBanks";
import { PartnerBank, PartnerBankKey } from "@ctypes/partners";

// Resolves the partner experience a user should see, or null.
//
// A partner shows only when all three line up: the user carries its partner id,
// the id is configured for this environment, and its flag is on. That is what
// lets each partner go live on its own signature date without a release.
export const findEnabledPartnerBank = (
  partnerId: string | null | undefined,
  partnerBankFlags: Partial<Record<PartnerBankKey, boolean>>,
): PartnerBank | null => {
  if (!partnerId) return null;

  const partnerBank = PARTNER_BANKS.find(
    (bank) => Boolean(bank.partnerId) && bank.partnerId === partnerId,
  );

  if (!partnerBank || !partnerBankFlags[partnerBank.key]) return null;

  return partnerBank;
};
